import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { NotificationsCard } from '@/features/settings/NotificationsCard';

/**
 * Tela `/settings` ("Configurações" do console super-admin). Hoje só hospeda
 * o card de Notificações (web push deste navegador).
 *
 * Origem: sem issue — commit 78c7c6157, 2026-05-12 (SettingsPage que faltou no
 * commit do web push).
 *
 * Usado por: rota `settings` (`routes/router.tsx`), menu Sistema
 * (`AdminLayout`, item com `end` porque `/settings` é prefixo das subrotas).
 * As demais configurações têm rota própria: `/settings/notifications`,
 * `/settings/super-admins`, `/settings/api-keys`, `/settings/app-versions`.
 *
 * Histórico:
 *  - 2026-10-10 13:39 +0200 — (#926) removida a menção ao "teste de SMS na aba
 *    SMS de /countries": a aba saiu em 2026-09-25 com o fim do OTP
 *    (`c7755754d`, #744).
 */
export function SettingsPage(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <ContentLayout
      header={<Header variant="h1" description={t('admin.settings.subtitle')}>{t('admin.settings.title')}</Header>}
    >
      <SpaceBetween size="l">
        <NotificationsCard />
      </SpaceBetween>
    </ContentLayout>
  );
}
